import * as React from "react";
import { connect } from "react-redux";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { IdTooltipAdjust } from "../../constants/IdTooltipAdjust";
import { IdStyles } from "../../less/IdStyles";
import { selectOutskirtBuildingLevel } from "../../selectors/selectOutskirtBuildingInfo";
import { selectWaterTowerResourceAmountInfo } from "../../selectors/selectWatertowerInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { BaseButton } from "../generic/base-button/BaseButton";
import { IdButtonType } from "../generic/base-button/IdButtonType";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalTabSelect } from "../modals/actionModal";
import { WaterTowerCategory } from "./WaterTowerCategory";
import { WaterTowerFilledStatus } from "./WaterTowerFilledStatus";
import { WaterTowerTimer } from "./WaterTowerTimer";
var _TabWaterTower = function (_a) {
    var waterTowerLevel = _a.waterTowerLevel, waterTowerResourceAmountInfo = _a.waterTowerResourceAmountInfo, onUpgradeClick = _a.onUpgradeClick;
    var levelLocaReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(waterTowerLevel)],
    ]);
    return (React.createElement("div", { className: "flex flex--around h100 w100" },
        React.createElement("div", { className: "water-tower-graphics-container" },
            React.createElement(WaterTowerFilledStatus, null),
            React.createElement(WaterTowerTimer, null)),
        React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around" },
            React.createElement("div", { className: "flex flex--stacked flex--aligned" },
                React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                    React.createElement(TextLoca, { className: IdStyles.HeadlineOne, id: IdLoca.watertower })),
                React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                    React.createElement(TextLoca, { className: IdStyles.HeadlineOne, id: IdLoca.stageX, replacements: levelLocaReplacements }))),
            React.createElement("div", { className: IdStyles.WaterCollectContainer + " flex flex--stacked flex--aligned flex--around" },
                React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.nextTimeCollect }),
                React.createElement("div", { className: IdStyles.WaterAmountContainer + " flex flex--aligned flex--centered" },
                    React.createElement(ResourceIcon, { resource: waterTowerResourceAmountInfo, styleId: IdStyles.IconMedium, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
                    React.createElement(NumberFormat, { className: IdStyles.TextNormal, amount: waterTowerResourceAmountInfo.amount }))),
            React.createElement(BaseButton, { name: IdStyles.ButtonPrimary, styleId: IdButtonType.ButtonRectangleExtraLarge, onClick: onUpgradeClick },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.upgrade })))));
};
var mapState = function (state) { return ({
    waterTowerLevel: selectOutskirtBuildingLevel(state, IdOutskirtBuildings.Watertower),
    waterTowerResourceAmountInfo: selectWaterTowerResourceAmountInfo(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onUpgradeClick: function () { return dispatch(actionModalTabSelect(WaterTowerCategory.Upgrade)); },
}); };
export var TabWaterTower = connect(mapState, mapDispatch)(_TabWaterTower);



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/TabWaterTower.tsx
// module id = 2804
// module chunks = 3